export default {
  clearAllPicks(context) {
    context.commit("CLEAR_ALL_PICKS");
  },
  async loadAllPicks(context) {
    const seasonId = context.rootGetters["seasons/currentSeason"].seasonId;
    // const token = context.rootGetters.token;

    console.group("loadAllPicks");
    console.info("Loading all picks for seasonId: " + seasonId);

    // don't bother loading if we don't have a season...yet
    if ( seasonId === null ) {
      // no season, clear the current picks list
      context.dispatch("clearAllPicks");
    } else {
      const response = await fetch(
        `https://ironman-2021-7de88-default-rtdb.firebaseio.com/picks/${seasonId}.json`
      );
      const responseData = await response.json();

      if (!response.ok) {
        const error = new Error(
          responseData.message || "Failed to fetch all picks."
        );
        throw error;
      }

      // successfully retrieved picks, clear the current ones
      context.dispatch("clearAllPicks");

      console.info("responseData = ", responseData);

      for (const key in responseData) {
        console.info("responseData[key].paid: ", responseData[key].paid);
        const picks = {
          nickName: responseData[key].nickName,
          picksComplete: responseData[key].picksComplete,
          paid: responseData[key].paid ? responseData[key].paid : false,
          userId: key,
          picksList: [],
        };

        console.info("picks.paid: ", picks.paid);

        for (let i = 0; i < responseData[key].picksList.length; i++) {
          const pick = {
            gameId: responseData[key].picksList[i].gameId,
            winner: responseData[key].picksList[i].winner,
          };

          picks.picksList.push(pick);
        }

        await context.dispatch("loadPick", picks);
      }
    }

    console.info("allPicksList = ", context.getters.allPicksList);
    console.groupEnd();
  },
  loadPick(context, pick) {
    context.commit("LOAD_PICK", pick);
  },
  createPick(context, payload) {
    console.group("createPick");
    console.log("payload = ", payload);

    const pick = {
      nickName: payload.nickName,
      picksComplete: payload.picksComplete,
      paid: payload.paid,
      userId: payload.userId,
      picksList: payload.picksList,
    };

    context.commit("CREATE_PICK", pick);  // add to allPicksList list
    context.dispatch("setCurrentPicks", pick.userId);  // add to currentPicks object
    context.dispatch("savePick");       // add to database (from currentPicks)
  },
  updatePick(context, pick) {
    context.commit("UPDATE_PICK", pick);
  },
  async savePick(context, newPick) {
    const token = context.rootGetters.token;
    const userId = newPick.userId;

    console.group("savePick")
    console.info("newPick = ", newPick);

    console.info("currentSeason = ", context.rootGetters["seasons/currentSeason"]);
    const seasonId = context.rootGetters["seasons/currentSeason"].seasonId;

    // remove userId element from newPick, it will be part of the Firebase "tree"
    delete newPick.userId;

    const response = await fetch(
      `https://ironman-2021-7de88-default-rtdb.firebaseio.com/picks/${seasonId}/${userId}.json?auth=` + token,
      {
        method: "PUT",
        body: JSON.stringify(newPick),
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      const error = new Error(
        responseData.message || "Failed to update Picks."
      );
      throw error;
    }

    // add userId back to newPick
    newPick.userId = userId;

    // push "updated" currentPicks back into allPicksList
    context.commit("UPDATE_PICK", newPick);  // update in allPicksList list
    if ( newPick.userId === context.rootGetters.userId ) {
      console.info("newPick.userId is the current user, calling SET_PICKS");
      context.commit("SET_PICKS", newPick.userId);  // update currentPicks with the new pick
    }
  },
  async setCurrentPicks(context, userId) {
    console.group("setCurrentPicks");

    if (context.rootGetters["seasons/currentSeason"].seasonId === null) {
      console.info("dispatching loadSeasons")
      await context.dispatch("seasons/loadSeasons", null, { root: true });
      console.info("finished dispatching loadSeasons")

    }

    if ( context.getters.allPicksList.length === 0 ) {
      console.info("dispatching loadAllPicks")
      await context.dispatch("loadAllPicks");
      console.info("finished dispatching loadAllPicks")
    }

    const pick = context.getters.allPicksList.filter((pick) => {
      return userId === pick.userId;
    });

    if (pick.length !== 1) {
      console.log("No picks for userId = " + userId);
      context.commit("CLEAR_PICKS");
    } else {
      console.info("calling SET_PICKS with userId = ", userId);
      context.commit("SET_PICKS", userId);
    }

    console.groupEnd();
  },
  clearCurrentPicks(context) {
    context.commit("CLEAR_PICKS");
  },
  setGamePicks(context, gamePicks) {
    context.commit("SET_GAMEPICK", gamePicks);
  }
};
